//TODO : Refactor after ai
import type { HTMLAttributes } from "react";
import type { StatusStep } from "./types";

export interface StatusBandProps extends Omit<HTMLAttributes<HTMLDivElement>, "onSelect"> {
  steps?: StatusStep[];
  /** The current state's value/label, or its index. */
  current?: string | number;
  onSelect?: (value: string, index: number) => void;
  interactive?: boolean;
}

/**
 * The object's lifecycle, laid out as one horizontal band of states — so the
 * user sees the whole lifecycle, not just the current value.
 */
export function StatusBand({
  steps = [],
  current,
  onSelect,
  interactive = true,
  className = "",
  ...rest
}: StatusBandProps) {
  const currentIndex =
    typeof current === "number"
      ? current
      : steps.findIndex((s) => (s.value ?? s.label) === current);

  return (
    <div
      className={`bui-status-band ${className}`}
      role="list"
      aria-label="Status"
      {...rest}
    >
      {steps.map((step, i) => {
        const state =
          step.state ??
          (i < currentIndex ? "done" : i === currentIndex ? "current" : "upcoming");
        const value = step.value ?? step.label;
        return (
          <button
            key={value}
            type="button"
            role="listitem"
            className="bui-status-step"
            data-state={state}
            data-static={!interactive || undefined}
            aria-current={state === "current" ? "step" : undefined}
            disabled={!interactive}
            onClick={() => interactive && onSelect?.(value, i)}
          >
            <span className="bui-status-step__dot" />
            {step.label}
          </button>
        );
      })}
    </div>
  );
}
